import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from './api';
import './StatsPage.css';

const LIMIT = 50;

function TopPlayers() {
  const navigate = useNavigate();
  const [country, setCountry] = useState('');
  const [countries, setCountries] = useState([]);
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/top-players/countries')
      .then((res) => setCountries(res.data.countries || []))
      .catch(() => setCountries([]));
  }, []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    api.get('/top-players', { params: { country: country || undefined, limit: LIMIT } })
      .then((res) => {
        if (!cancelled) setPlayers(res.data.top_players || []);
      })
      .catch((err) => {
        if (!cancelled) setError(err.response?.data?.detail || err.message || 'Failed to load');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [country]);

  return (
    <div className="stats-wrap">
      <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
      <h2 className="page-title">Top 50 Players</h2>
      <div className="stats-controls">
        <div className="controls-row">
          <select
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            aria-label="Filter by country"
          >
            <option value="">Global (all countries)</option>
            {countries.map((c) => (
              <option key={c.country} value={c.country}>
                {String(c.country).toUpperCase()} ({c.players} players)
              </option>
            ))}
          </select>
        </div>
      </div>
      {loading && <div>Loading…</div>}
      {error && <div className="error">Error: {error}</div>}
      {!loading && !error && players.length === 0 && <div>No players found.</div>}
      {!loading && !error && players.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Country</th>
              <th>Matches</th>
            </tr>
          </thead>
          <tbody>
            {players.map((p) => (
              <tr key={p.name + (p.team || '')}>
                <td>{p.rank}</td>
                <td>
                  {p.name}
                  {p.team ? (
                    <span className="top-player-team" style={{ marginLeft: 8, fontSize: '0.8em', opacity: 0.6 }}>
                      {p.team}
                    </span>
                  ) : null}
                </td>
                <td>{p.country ? String(p.country).toUpperCase() : ''}</td>
                <td>{p.matches}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default TopPlayers;
